// NOTE: sometimes there are multiple "billing IK numbers" per insurance. We can only offer the insurances main IK number.
// Current data as PDF can be found at https://institut-ba.de/service/schluesselverzeichnisse -> "Schlüsselverzeichnis 8: Verzeichnis der Kassensitz-IK"
export const legacyPublicInsurances = [
// { name: 'Test-KK', id: 'test-kk', supported: true },
// { name: 'Test-X', supported: true, id: 'test-x' },
{
  name: 'Barmer',
  supported: true,
  id: 'barmer',
  ik: '104940005'
}, {
  name: 'DAK Gesundheit',
  supported: true,
  id: 'dak-gesundheit',
  ik: '101560000'
}, {
  name: 'HEK Hanseatische Krankenkasse',
  supported: true,
  id: 'hek-hanseatische-krankenkasse',
  ik: '101570104'
}, {
  name: 'hkk Krankenkasse',
  supported: true,
  id: 'hkk-krankenkasse',
  ik: '103170002'
}, {
  name: 'KKH Kaufmännische Krankenkasse',
  supported: true,
  id: 'kkh-kaufmannische-krankenkasse',
  ik: '102171012'
}, {
  name: 'Knappschaft',
  supported: true,
  id: 'knappschaft',
  ik: '109905003'
}, {
  name: 'TK Techniker Krankenkasse',
  supported: true,
  id: 'tk-techniker-krankenkasse',
  ik: '101575519'
}, {
  name: 'BIG direkt gesund',
  supported: true,
  id: 'big-direkt-gesund',
  ik: '103501080'
}, {
  name: 'IKK Die Innovationskasse West',
  supported: true,
  id: 'ikk-die-innovationskasse-west',
  ik: '101300129'
}, {
  name: 'IKK Die Innovationskasse Ost',
  supported: true,
  id: 'ikk-die-innovationskasse-ost',
  ik: '100202549'
}, {
  name: 'IKK Brandenburg und Berlin',
  supported: true,
  id: 'ikk-brandenburg-und-berlin',
  ik: '100602360'
}, {
  name: 'IKK classic',
  supported: true,
  id: 'ikk-classic',
  ik: '107202793'
}, {
  name: 'IKK gesund plus',
  supported: true,
  id: 'ikk-gesund-plus',
  ik: '101202961'
}, {
  name: 'IKK Südwest',
  supported: true,
  id: 'ikk-sudwest',
  ik: '109303301'
}, {
  name: 'AOK Baden-Württemberg',
  supported: true,
  id: 'aok-baden-wurttemberg',
  ik: '108018007'
}, {
  name: 'AOK Bayern',
  supported: true,
  id: 'aok-bayern',
  ik: '108310400'
}, {
  name: 'AOK Bremen/Bremerhaven',
  supported: true,
  id: 'aok-bremen-bremerhaven',
  ik: '103119199'
}, {
  name: 'AOK Hessen',
  supported: true,
  id: 'aok-hessen',
  ik: '105313145'
}, {
  name: 'AOK Niedersachsen',
  supported: true,
  id: 'aok-niedersachsen',
  ik: '102114819'
}, {
  name: 'AOK Nordost',
  supported: true,
  id: 'aok-nordost',
  ik: '100696012'
}, {
  name: 'AOK Nordwest',
  supported: true,
  id: 'aok-nordwest',
  ik: '103411401'
}, {
  name: 'AOK PLUS',
  supported: true,
  id: 'aok-plus',
  ik: '107299005'
}, {
  name: 'AOK Rheinland-Pfalz/Saarland',
  supported: true,
  id: 'aok-rheinland-pfalz-saarland',
  ik: '107310373'
}, {
  name: 'AOK Rheinland/Hamburg',
  supported: true,
  id: 'aok-rheinland-hamburg',
  ik: '104212505'
}, {
  name: 'AOK Sachsen-Anhalt',
  supported: true,
  id: 'aok-sachsen-anhalt',
  ik: '101097008'
}, {
  name: 'Audi BKK',
  supported: true,
  id: 'audi-bkk',
  ik: '108534160'
}, {
  name: 'BAHN BKK',
  supported: true,
  id: 'bahn-bkk',
  ik: '109938503'
}, {
  name: 'Bergische Krankenkasse',
  supported: true,
  id: 'bergische-krankenkasse',
  ik: '104926702'
}, {
  name: 'Bertelsmann BKK',
  supported: true,
  id: 'bertelsmann-bkk',
  ik: '103725342'
}, {
  name: 'BKK Akzo Nobel Bayern',
  supported: true,
  id: 'bkk-akzo-nobel-bayern',
  ik: '108833355'
}, {
  name: 'BKK Diakonie',
  supported: true,
  id: 'bkk-diakonie',
  ik: '103724294'
}, {
  name: 'BKK DürkoppAdler',
  supported: true,
  id: 'bkk-durkoppadler',
  ik: '103724249'
}, {
  name: 'BKK Euregio',
  supported: true,
  id: 'bkk-euregio',
  ik: '104125509'
}, {
  name: 'BKK exklusiv',
  supported: true,
  id: 'bkk-exklusiv',
  ik: '102122557'
}, {
  name: 'BKK Faber-Castell & Partner',
  supported: true,
  id: 'bkk-faber-castell-and-partner',
  ik: '109033393'
}, {
  name: 'BKK firmus',
  supported: true,
  id: 'bkk-firmus',
  ik: '103121137'
}, {
  name: 'BKK Freudenberg',
  supported: true,
  id: 'bkk-freudenberg',
  ik: '107036370'
}, {
  name: 'BKK Gildemeister Seidensticker',
  supported: true,
  id: 'bkk-gildemeister-seidensticker',
  ik: '103724272'
}, {
  name: 'BKK Herkules',
  supported: true,
  id: 'bkk-herkules',
  ik: '105530331'
}, {
  name: 'BKK Linde',
  supported: true,
  id: 'bkk-linde',
  ik: '105830517'
}, {
  name: 'BKK melitta hmr',
  supported: true,
  id: 'bkk-melitta-hmr',
  ik: '103726081'
}, {
  name: 'BKK Pfaff',
  supported: true,
  id: 'bkk-pfaff',
  ik: '106431572'
}, {
  name: 'BKK Pfalz',
  supported: true,
  id: 'bkk-pfalz',
  ik: '106431652'
}, {
  name: 'BKK ProVita',
  supported: true,
  id: 'bkk-provita',
  ik: '108591499'
}, {
  name: 'BKK Public',
  supported: true,
  id: 'bkk-public',
  ik: '105723301'
}, {
  name: 'BKK SBH',
  supported: true,
  id: 'bkk-sbh',
  ik: '107531187'
}, {
  name: 'BKK Scheufelen',
  supported: true,
  id: 'bkk-scheufelen',
  ik: '108035576'
}, {
  name: 'BKK Technoform',
  supported: true,
  id: 'bkk-technoform',
  ik: '102031410'
}, {
  name: 'BKK Textilgruppe Hof',
  supported: true,
  id: 'bkk-textilgruppe-hof',
  ik: '108632900'
}, {
  name: 'BKK VBU Verkehrsbau Union',
  supported: true,
  id: 'bkk-vbu',
  ik: '109723913'
}, {
  name: 'BKK VDN',
  supported: true,
  id: 'bkk-vdn',
  ik: '103526615'
}, {
  name: 'BKK VerbundPlus',
  supported: true,
  id: 'bkk-verbundplus',
  ik: '107832012'
}, {
  name: 'BKK Werra-Meissner',
  supported: true,
  id: 'bkk-werra-meissner',
  ik: '105530126'
}, {
  name: 'BKK Wirtschaft & Finanzen',
  supported: true,
  id: 'bkk-wirtschaft-and-finanzen',
  ik: '107836243'
}, {
  name: 'BKK ZF & Partner',
  supported: true,
  id: 'bkk-zf-and-partner',
  ik: '107829563'
}, {
  name: 'BKK24',
  supported: true,
  id: 'bkk24',
  ik: '102122660'
}, {
  name: 'Bosch BKK',
  supported: true,
  id: 'bosch-bkk',
  ik: '108036123'
}, {
  name: 'Continentale BKK',
  supported: true,
  id: 'continentale-bkk',
  ik: '103523440'
}, {
  name: 'Debeka BKK',
  supported: true,
  id: 'debeka-bkk',
  ik: '106329225'
}, {
  name: 'energie BKK',
  supported: true,
  id: 'energie-bkk',
  ik: '102129930'
}, {
  name: 'Heimat Krankenkasse',
  supported: true,
  id: 'heimat-krankenkasse',
  ik: '103724238'
}, {
  name: 'mhplus Krankenkasse',
  supported: true,
  id: 'mhplus-krankenkasse',
  ik: '108035612'
}, {
  name: 'Mobil Krankenkasse',
  supported: true,
  id: 'mobil-krankenkasse',
  ik: '101520078'
}, {
  name: 'Novitas BKK',
  supported: true,
  id: 'novitas-bkk',
  ik: '104491707'
}, {
  name: 'Pronova BKK',
  supported: true,
  id: 'pronova-bkk',
  ik: '106492393'
}, {
  name: 'R+V Betriebskrankenkasse',
  supported: true,
  id: 'rv-betriebskrankenkasse',
  ik: '105823040'
}, {
  name: 'Salus BKK',
  supported: true,
  id: 'salus-bkk',
  ik: '105330168'
}, {
  name: 'Siemens Betriebskrankenkasse SBK',
  supported: true,
  id: 'sbk',
  ik: '108433248'
}, {
  name: 'Securvita Krankenkasse',
  supported: true,
  id: 'securvita-krankenkasse',
  ik: '101320032'
}, {
  name: 'SKD BKK',
  supported: true,
  id: 'skd-bkk',
  ik: '108833505'
}, {
  name: 'TUI BKK',
  supported: true,
  id: 'tui-bkk',
  ik: '102137985'
}, {
  name: 'Viactiv Krankenkasse',
  supported: true,
  id: 'viactiv-krankenkasse',
  ik: '104526376'
}, {
  name: 'vivida BKK West',
  supported: true,
  id: 'vivida-bkk',
  ik: '107536262'
}, {
  name: 'vivida BKK Ost',
  supported: true,
  id: 'vivida-bkk-ost',
  ik: '107536262'
}, {
  name: 'WMF BKK',
  supported: true,
  id: 'wmf-bkk',
  ik: '108036441'
}, {
  name: 'LKK Gartenbau - Landwirtschaftliche Krankenkasse',
  supported: true,
  id: 'landwirtschaftliche-krankenkasse-lkk',
  ik: '102109128'
}, {
  name: 'BKK B. Braun Aesculap',
  supported: true,
  id: 'bkk-b-braun-aesculap',
  ik: '107536171'
}, {
  name: 'BKK BPW Bergische Achsen KG',
  supported: true,
  id: 'bkk-bpw-bergische-achsen-kg',
  ik: '104626903'
}, {
  name: 'BKK Deutsche Bank AG',
  supported: true,
  id: 'bkk-deutsche-bank-ag',
  ik: '104224634'
}, {
  name: 'BKK evm',
  supported: true,
  id: 'bkk-evm',
  ik: '106331593'
}, {
  name: 'BKK EWE',
  supported: true,
  id: 'bkk-ewe',
  ik: '102429648'
}, {
  name: 'BKK Groz-Beckert',
  supported: true,
  id: 'bkk-groz-beckert',
  ik: '104424830'
}, {
  name: 'BKK Karl Mayer',
  supported: true,
  id: 'bkk-karl-mayer',
  ik: '105330431'
}, {
  name: 'BKK Mahle',
  supported: true,
  id: 'bkk-mahle',
  ik: '108036145'
}, {
  name: 'BKK Merck',
  supported: true,
  id: 'bkk-merck',
  ik: '105230076'
}, {
  name: 'BKK Miele',
  supported: true,
  id: 'bkk-miele',
  ik: '103725364'
}, {
  name: 'BKK MTU',
  supported: true,
  id: 'bkk-mtu',
  ik: '107835333'
}, {
  name: 'BKK PwC (PricewaterhouseCoopers)',
  supported: true,
  id: 'bkk-pwc',
  ik: '101931440'
}, {
  name: 'BKK Rieker Ricosta Weisser',
  supported: true,
  id: 'bkk-rieker-ricosta-weisser',
  ik: '107532042'
}, {
  name: 'BKK Salzgitter',
  supported: true,
  id: 'bkk-salzgitter',
  ik: '101922757'
}, {
  name: 'BKK Voralb Heller Index Leuze',
  supported: true,
  id: 'bkk-voralb-heller-index-leuze',
  ik: '108031424'
}, {
  name: 'BKK Würth',
  supported: true,
  id: 'bkk-wurth',
  ik: '108036577'
}, {
  name: 'BMW BKK',
  supported: true,
  id: 'bmw-bkk',
  ik: '109034270'
}, {
  name: 'Ernst & Young BKK',
  supported: true,
  id: 'ernst-and-young-bkk',
  ik: '105732324'
}, {
  name: 'Koenig & Bauer BKK',
  supported: true,
  id: 'koenig-and-bauer-bkk',
  ik: '108833674'
}, {
  name: 'Krones BKK',
  supported: true,
  id: 'krones-bkk',
  ik: '108934142'
}, {
  name: 'Mercedes-Benz BKK West',
  supported: true,
  id: 'mercedes-benz-bkk',
  ik: '108030775'
}, {
  name: 'Mercedes-Benz BKK Ost',
  supported: true,
  id: 'mercedes-benz-bkk-ost',
  ik: '108038078'
}, {
  name: 'Südzucker BKK',
  supported: true,
  id: 'sudzucker-bkk',
  ik: '106936311'
},
// following insurances were marked as fusioned but not mentioned in the full list.
{
  name: 'actimonda',
  supported: true,
  id: 'actimonda',
  ik: '104127692'
}, {
  name: 'Metzinger BKK',
  supported: true,
  id: 'metzinger-bkk',
  ik: '108035612'
}, {
  name: 'BKK Mobil Oil',
  supported: true,
  id: 'bkk-mobil-oil',
  ik: '101520078'
}, {
  name: 'BKK mhplus',
  supported: true,
  id: 'mhplus',
  ik: '108035612'
}];
export const legacyPrivateInsurances = [{
  name: "Allianz Private Krankenversicherung",
  id: "allianz"
}, {
  name: "Alte Oldenburger Krankenversicherung",
  id: "alte-oldenburger"
}, {
  name: "ARAG Krankenversicherung",
  id: "arag"
}, {
  name: "AXA Krankenversicherung",
  id: "axa"
}, {
  name: "Barmenia Krankenversicherung",
  id: "barmenia"
}, {
  name: "Concordia Krankenversicherung",
  id: "concordia"
}, {
  name: "Continentale Krankenversicherung",
  id: "continentale"
}, {
  name: "Debeka Krankenversicherung",
  id: "debeka"
}, {
  name: "DEVK Krankenversicherung",
  id: "devk"
}, {
  name: "Die Bayerische - BBL",
  id: "bayerische-bbl"
}, {
  name: "DKV Deutsche Krankenversicherung",
  id: "dvk"
}, {
  name: "ENVIVAS Krankenversicherung",
  id: "envivas"
}, {
  name: "ERGO Direkt Krankenversicherung",
  id: "ergo-direkt"
}, {
  name: "Generali Krankenversicherung",
  id: "generali"
}, {
  name: "Gothaer Krankenversicherung",
  id: "gothaer"
}, {
  name: "HALLESCHE Krankenversicherung",
  id: "hallesche"
}, {
  name: "HanseMerkur Krankenversicherung",
  id: "hansemerkur"
}, {
  name: "HUK-Coburg-Krankenversicherung",
  id: "huk-coburg"
}, {
  name: "Inter Krankenversicherung",
  id: "inter"
}, {
  name: "LKH Landeskrankenhilfe",
  id: "lkh"
}, {
  name: "LVM Krankenversicherungs",
  id: "lvm"
}, {
  name: "Mecklenburgische Krankenversicherung",
  id: "mecklenburgische"
}, {
  name: "Münchener Verein Krankenversicherung",
  id: "muenchener-verein"
}, {
  name: "Nürnberger Krankenversicherung",
  id: "nuernburger"
}, {
  name: "R+V Krankenversicherung",
  id: "r-v"
}, {
  name: "Signal Krankenversicherung",
  id: "signal"
}, {
  name: "Süddeutsche Krankenversicherung",
  id: "sueddeutsche"
}, {
  name: "UKV - Union Krankenversicherung",
  id: "ukv"
}, {
  name: "Universa Krankenversicherung",
  id: "universa"
}, {
  name: "Versicherungskammer Bayern",
  id: "versicherungskammer-bayern"
}, {
  name: "vigo Krankenversicherung",
  id: "vigo"
}, {
  name: "Württembergische Krankenversicherung",
  id: "wuerttembergische"
}];